import { useRef, useEffect, useReducer } from 'react';
/**
 * Hook som hanterar state ungefär som klass-komponenter med en callback som körs efter setState.
 * För att konvertera komponenter som tidigare varit klasser.
 */
export default function useStateCallback<S>(initialState: S) {
  const [state, setState] = useReducer((state: S, newState: Partial<S>) => {
    if (typeof newState === 'object') {
      return { ...state, ...newState };
    }
    return newState;
  }, initialState);

  const cbRef = useRef<((state: S) => void) | null>(null);

  function setStateCallback(state: Partial<S>, cb?: (state: S) => void) {
    if (cb) {
      cbRef.current = cb;
    }
    setState(state);
  }
  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null;
    }
  }, [state]);

  return [state, setStateCallback] as const;
}
